import React from 'react';
export function OriginStory() {
  return <section className="py-12 bg-[#FDF8F4] px-4" data-id="element-219">
      <div className="max-w-2xl mx-auto text-center" data-id="element-220">
        <div className="w-14 h-14 bg-[#B8A9C9]/20 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl" data-id="element-221">
          👩‍🦰
        </div>
        <h2 className="text-2xl font-serif font-bold text-gray-900 mb-6" data-id="element-222">
          Por qué creé este Ebook
        </h2>

        <div className="bg-white rounded-2xl border border-[#C06B6B]/10 p-6 text-left space-y-3 text-sm text-gray-600" data-id="element-223">
          <p className="italic text-gray-700" data-id="element-224">
            2:47am. Mente a mil por hora. Ansiedad a tope.
          </p>
          <p className="font-medium text-[#C06B6B]" data-id="element-225">
            De día funcionaba. De noche mi mente colapsaba. Nadie lo veía.
          </p>
          <p data-id="element-226">
            Terapia, meditación, medicación… nada funcionaba cuando mi mente ya
            estaba en alerta.
          </p>
          <p data-id="element-227">
            Una noche probé una técnica de respiración diferente. Un
            micro-segundo de silencio interno.
          </p>
          <p className="font-bold text-gray-900" data-id="element-228">
            Fue mínimo. Pero fue real. Y por primera vez en años… mi mente
            descansó.
          </p>
          <p data-id="element-229">
            Estudié neurofisiología del estrés. Probé. Simplifiqué. Así nació
            este método.
          </p>
        </div>

        <p className="mt-4 font-bold text-gray-900" data-id="element-230">
          Hoy más de 2,400 personas lo usan.
        </p>
      </div>
    </section>;
}